import React, {Component} from 'react';
import {Form} from "react-bootstrap";

class ExpandedChoice extends Component {
    setAnswer = (e) => {
        let val = e.target.value
        val = val==="true" ? true: val==="false" ? false: val
        if (!isNaN(val) && ![true,false].includes(val)){
            val = parseInt(val)
        }
        this.props.setAnswer(val)
    }
    render() {
        return (
            <div className="row sussd-radio d-flex flex-wrap justify-content-evenly g-2">
                {
                    this.props.choices.map((choice,i)=>{
                        const Label = <div className={`d-flex flex-column align-items-center ${choice?.icon ? 'py-2':'py-3'} px-3`}>{choice.icon} <span
                            className="text-nowrap">{choice.text} </span></div>
                        const id = this.props.elementProps.id+choice.value

                        return (
                        <Form.Check key={id}
                                    className={`col transitionable delay-${2+i}`}
                                    onClick={this.setAnswer}
                                    type="radio"
                                    id={id}
                                    name={this.props.elementProps.id} label={Label}
                                    value={choice.value}
                                    defaultChecked={this.props.elementProps.defaultValue === choice.value}/>
                        )
                    })
                }
                <Form.Control type={"hidden"}
                              isInvalid={this.props.elementProps.isInvalid}
                              isValid={this.props.elementProps.isValid}
                />

            </div>
        );
    }
}

export default ExpandedChoice;